import React from "react";
import { getField, deserializeField } from "../../../../util/DynamicItemUtils";

export default function ResponsibilityNotDivided({ item }: any) {
  const auditNotDividedPercent = deserializeField(
    item,
    "auditnotdividedpercent"
  );
  const numberOfParticipants = getField(item, "numberofparticipants");
  const participantRange = getField(item, "participantrange");
  const participantPercentage = getField(item, "participantpercentage");

  function generateFirmCardFivePercentOrGreater(firmsInfo) {
    return firmsInfo.map((firm) => {
      const formattedLocation = [firm.City, firm.State, firm.Country]
        .filter((x) => !!x && x !== "United States")
        .join(", ");
      return (
        <div className="firm-details">
          <p>
            <strong className="break-word">{firm.FirmName}</strong>
          </p>
          <p>{`FirmID: ${firm.FirmID.length > 0 ? firm.FirmID : "N/A"}`}</p>
          {formattedLocation && (
            <p>{`Headquarters' Office: ${formattedLocation}`}</p>
          )}
          <p>{`Extent of Participation: ${
            firm.Range ? firm.Range : firm.Percentage + "%"
          }`}</p>
        </div>
      );
    });
  }

  return (
    <div className="form-card">
      <h2>
        Participation of Other Accounting Firms - Responsibility Not Divided
      </h2>
      <h3>
        Other Accounting Firm(s) individually 5% or greater of total audit hours
      </h3>
      {auditNotDividedPercent ? (
        <div className="firm-details__container">
          {generateFirmCardFivePercentOrGreater(auditNotDividedPercent[0])}
        </div>
      ) : (
        <em>
          <p>None reported</p>
        </em>
      )}
      <h3>
        Other Accounting Firm(s) individually less than 5% of total audit hours
      </h3>
      {numberOfParticipants ? (
        <div className="firm-details">
          <p>{`Number of Firms: ${numberOfParticipants
            .replace("+000000000000000", "")
            .replace(".0000", "")}`}</p>
          <p>{`Aggregate participation: ${
            participantRange ? participantRange : participantPercentage + "%"
          }`}</p>
        </div>
      ) : (
        <em>
          <p>None reported</p>
        </em>
      )}
    </div>
  );
}
